<template>
  <v-card v-resize="onResize" :height="height">
    <v-card class="mx-auto">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-btn
              v-if="company.ConsortiumId"
              outlined
              small
              class="text-h5 success--text"
              :to="{ path: `/consortium/${company.ConsortiumId}` }"
            >
              {{ company.Consortium.name }}
            </v-btn>
            <div class="text-h5">
              {{ company.name }}
            </div>
            <div>
              {{ company.address }}
              {{ company.city }}, {{ company.state }} {{ company.zip }}<br />
              {{ company.phone }}<br />
              NOTES: {{ company.description }}
            </div>
            <div class="mt-2">
              <v-row>
                <v-col
                  v-if="company.TestType"
                  class="text-h6 primary--text"
                  cols="12"
                >
                  {{ company.TestType.name }}
                </v-col>
                <v-col v-else class="text-h6 primary--text" cols="12">
                  Statistics
                </v-col>
                <v-col
                  cols="4"
                  class="text-center font-weight-black"
                  v-if="company.percentDrug > 0"
                >
                  {{ company.percentDrug }}% Drug
                </v-col>
                <v-col
                  cols="4"
                  class="text-center font-weight-black"
                  v-if="company.percentAlcohol > 0"
                >
                  {{ company.percentAlcohol }}% Drug/Alcohol
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-center" cols="4">
                  Draws - Avg<br />
                  {{ stats.noDraws }} - {{ stats.avgDraws }}
                </v-col>
                <v-col class="text-center" cols="4">
                  Drug Percent<br />
                  {{ stats.percentDrug }}
                </v-col>
                <v-col class="text-center" cols="4">
                  Alcohol Percent<br />
                  {{ stats.percentAlcohol }}
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <v-container>
              <v-row>
                <v-col class="text-h6 primary--text" cols="12">
                  Current Draw
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="amountDrug"
                    label="Drug Draw"
                    v-mask="drawMask"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="amountAlcohol"
                    label="Drug/Alcohol Draw"
                    v-mask="drawMask"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="amountAltDrug"
                    label="Alt Drug Draw"
                    v-mask="drawMask"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="amountAltAlcohol"
                    label="Alt Drug/Alcohol Draw"
                    v-mask="drawMask"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12" md="9">
                  <v-text-field
                    v-model="emailTo"
                    label="Email To"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    v-model="emailMe"
                    label="Email Me"
                    color="success"
                    hide-details
                    @click="updateEmail()"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-app-bar
      color="white"
      elevation="0"
      scroll-target="#scrolling-techniques-7"
    >
      <v-checkbox
        v-model="selectAll"
        :label="numberSelected"
        @click.stop="selectAllTeam"
        :indeterminate="indeterminate"
        hide-details
      ></v-checkbox>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="primary"
      ></v-progress-linear>

      <v-spacer></v-spacer>

      <!-- <v-btn fab small color="primary" class="mr-4">
        <v-icon @click="sendDraw">mdi-email</v-icon>
      </v-btn> -->
      <v-btn fab small color="primary" class="hidden-sm-and-down mr-4">
        <v-icon @click="showCompanyEdit = !showCompanyEdit">
          mdi-briefcase-edit
        </v-icon>
      </v-btn>
      <v-btn fab small color="primary" class="hidden-sm-and-down mr-4">
        <v-icon @click="getUpload">mdi-account-switch</v-icon>
      </v-btn>
      <!-- <v-btn fab small color="primary" class="hidden-sm-and-down mr-4">
        <v-icon @click="downloadPdf">mdi-printer</v-icon>
      </v-btn> -->
      <v-btn fab small color="primary" class="hidden-sm-and-down mr-6">
        <v-icon @click="getRandom">mdi-selection-ellipse-arrow-inside</v-icon>
      </v-btn>
      <v-btn fab small color="primary" class="hidden-sm-and-down mr-6">
        <v-icon @click="getPrevious">mdi-account-multiple-check-outline</v-icon>
      </v-btn>

      <v-text-field
        v-model="search"
        label="Search Employees"
        prepend-icon="mdi-magnify"
        v-on:keyup="searchProducts"
        clearable
        @click:clear="clearMessage"
        hide-details
        class="hidden-sm-and-down pl-4"
      />

      <v-menu :nudge-width="200" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            small
            color="primary"
            v-on="on"
            class="hidden-md-and-up mr-4"
          >
            <v-icon dark>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-subheader>SELECT OPTION</v-subheader>
          <v-list-item-group color="primary">
            <v-list-item :disabled="disable">
              <v-list-item-icon>
                <v-icon :disabled="disable" color="primary">
                  mdi-cloud-download
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Download Selected
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item :disabled="disable" @click="downloadPdf">
              <v-list-item-icon>
                <v-icon :disabled="disable" color="primary">mdi-printer</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Print
              </v-list-item-content>
            </v-list-item>
            <v-list-item :disabled="disable" @click="getRandom">
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-selection-ellipse-arrow-inside
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Draw
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            small
            color="primary"
            v-on="on"
            class="hidden-md-and-up"
          >
            <v-icon dark>mdi-magnify</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-subheader>SEARCH</v-subheader>
            <v-divider></v-divider>
            <v-list-item>
              <v-text-field
                v-model="search"
                label="Search Products"
                prepend-icon="mdi-magnify"
                v-on:keyup="searchProducts"
                clearable
                @click:clear="clearMessage"
                hide-details
              />
            </v-list-item>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="menu = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-card>
      <v-row no-gutters>
        <v-col v-if="showUpload" class="cols-12 md-6" order-sm="1">
          <v-sheet
            v-resize="onResize"
            :height="height"
            id="scrolling-techniques-7"
            class="overflow-y-auto"
          >
            <v-container style="margin-bottom: 120px; padding: 0;">
              <div class="panel panel-sm">
                <div class="panel-body">
                  <div class="form-group">
                    <label
                      for="csv_file"
                      class="control-label col-sm-3 text-right"
                    >
                      Client file to import
                    </label>
                    <div class="col-sm-9">
                      <v-file-input
                        truncate-length="50"
                        @change="loadCSV($event)"
                      ></v-file-input>
                      <v-btn
                        v-if="loadButton"
                        depressed
                        color="primary"
                        @click="addList"
                      >
                        Load
                      </v-btn>
                    </div>
                  </div>
                  <div class="col-sm-offset-3 col-sm-9">
                    <div class="checkbox-inline">
                      <label for="header_rows">
                        <input
                          v-model="header"
                          type="checkbox"
                          id="header_rows"
                        />
                        File contains header row?
                      </label>
                    </div>
                  </div>

                  <v-list v-if="csv.length" class="pl-4">
                    <template v-for="(employee, index) in csv">
                      <v-lazy :key="index" transition="fade-transition">
                        <v-list-item link @click="updateList(employee)">
                          <v-list-item-title>
                            {{ employee.firstName }}
                            {{ employee.lastName }}
                          </v-list-item-title>
                          <v-list-item-icon v-if="employee.action === 'ADD'">
                            <v-icon color="blue darken-2">
                              mdi-account-plus-outline
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-icon v-if="employee.action === 'DELETE'">
                            <v-icon color="red darken-2">
                              mdi-account-cancel-outline
                            </v-icon>
                          </v-list-item-icon>
                        </v-list-item>
                      </v-lazy>
                      <v-divider
                        v-if="index + 1 < csv.length"
                        :key="`divider-${index}`"
                      ></v-divider>
                    </template>
                  </v-list>
                </div>
              </div>
            </v-container>
          </v-sheet>
        </v-col>
        <v-col v-if="showDraws" class="cols-12 md-6" order-sm="1">
          <v-sheet
            v-resize="onResize"
            :height="height"
            id="scrolling-techniques-7"
            class="overflow-y-auto"
          >
            <v-container style="margin-bottom: 120px; padding: 0;">
              <v-card class="mx-auto" outlined>
                <h3 v-if="prevDraws.length" class="ml-2">
                  PREVIOUS COMPANY DRAWS
                </h3>

                <v-virtual-scroll
                  v-if="prevDraws.length"
                  :bench="benched"
                  :items="prevDraws"
                  :height="height - 180"
                  item-height="64"
                >
                  <template v-slot:default="{ item }">
                    <v-list-item :key="item.id" @click="getDraw(item.id)">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.date }} (No. Emps - {{ item.number }})
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-btn icon @click="getDraw(item.id)">
                          <v-icon color="primary">mdi-pencil</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>

                    <v-divider></v-divider>
                  </template>
                </v-virtual-scroll>
                <h3 v-if="prevConsortiumDraws.length" class="ml-2">
                  PREVIOUS CONSORTIUM DRAWS
                </h3>

                <v-virtual-scroll
                  v-if="prevConsortiumDraws.length"
                  :bench="benched"
                  :items="prevConsortiumDraws"
                  :height="height - 180"
                  item-height="64"
                >
                  <template v-slot:default="{ item }">
                    <v-list-item
                      :key="item.id"
                      @click="getCoDraw(companyId, item.id, item.createdAt)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.date }}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-btn
                          icon
                          @click="getCoDraw(companyId, item.id, item.createdAt)"
                        >
                          <v-icon color="primary">mdi-pencil</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>

                    <v-divider></v-divider>
                  </template>
                </v-virtual-scroll>
              </v-card>
            </v-container>
          </v-sheet>
        </v-col>
        <v-col v-if="showDraw" class="cols-12 md-6" order-sm="1">
          <v-sheet
            v-resize="onResize"
            :height="height"
            id="scrolling-techniques-7"
            class="overflow-y-auto"
          >
            <v-container
              v-if="showNewDraw"
              style="margin-bottom: 120px; padding: 0;"
            >
              <v-card class="mx-auto" outlined>
                <h3 v-if="showNewDraw" class="ml-2">
                  Pending Draws
                </h3>
                <v-virtual-scroll
                  :bench="benched"
                  :items="pendingDraws"
                  :height="height"
                  item-height="64"
                >
                  <template v-slot:default="{ item }">
                    <v-list-item :key="item.id" :class="item.lastDraw">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.createdAt }} - {{ item.status }}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <div class="text-center">
                          <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                                color="blue"
                                @click="showUpload = false"
                              >
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Draw List</span>
                          </v-tooltip>
                          <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                                color="red"
                                @click="showUpload = false"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                            <span>Cancel</span>
                          </v-tooltip>
                        </div>
                      </v-list-item-action>
                    </v-list-item>

                    <v-divider></v-divider>
                  </template>
                </v-virtual-scroll>
              </v-card>
            </v-container>
            <v-container v-else style="margin-bottom: 120px; padding: 0;">
              <v-card class="mx-auto" outlined>
                <h3 v-if="randomDraw.length" class="ml-2">
                  DRUG
                </h3>
                <v-list v-if="randomDraw.length">
                  <template v-for="(employee, index) in randomDraw">
                    <v-lazy :key="index" transition="fade-transition">
                      <v-list-item>
                        <v-list-item-content class="pl-4 text-left">
                          <v-list-item-title
                            v-text="employee.name"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-lazy>
                    <v-divider
                      v-if="index + 1 < randomDraw.length"
                      :key="`divider-${index}`"
                    ></v-divider>
                  </template>
                </v-list>
                <h3 v-if="randomAlcohol.length" class="ml-2">
                  DRUG & ALCOHOL
                </h3>
                <v-list v-if="randomAlcohol.length">
                  <template v-for="(employee, index) in randomAlcohol">
                    <v-lazy :key="index" transition="fade-transition">
                      <v-list-item>
                        <v-list-item-content class="pl-4 text-left">
                          <v-list-item-title
                            v-text="employee.name"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-lazy>
                    <v-divider
                      v-if="index + 1 < randomAlcohol.length"
                      :key="`divider-${index}`"
                    ></v-divider>
                  </template>
                </v-list>
                <h3 v-if="randomAltDraw.length" class="ml-2">
                  DRUG (Alternate)
                </h3>
                <v-list v-if="randomAltDraw.length">
                  <template v-for="(employee, index) in randomAltDraw">
                    <v-lazy :key="index" transition="fade-transition">
                      <v-list-item>
                        <v-list-item-content class="pl-4 text-left">
                          <v-list-item-title
                            v-text="employee.name"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-lazy>
                    <v-divider
                      v-if="index + 1 < randomAltDraw.length"
                      :key="`divider-${index}`"
                    ></v-divider>
                  </template>
                </v-list>
                <h3 v-if="randomAltAlcohol.length" class="ml-2">
                  DRUG & Alcohol (Alternate)
                </h3>
                <v-list v-if="randomAltAlcohol.length">
                  <template v-for="(employee, index) in randomAltAlcohol">
                    <v-lazy :key="index" transition="fade-transition">
                      <v-list-item>
                        <v-list-item-content class="pl-4 text-left">
                          <v-list-item-title
                            v-text="employee.name"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-lazy>
                    <v-divider
                      v-if="index + 1 < randomAltAlcohol.length"
                      :key="`divider-${index}`"
                    ></v-divider>
                  </template>
                </v-list>
              </v-card>
            </v-container>
          </v-sheet>
        </v-col>
        <v-col class="cols-12 md-6" order-sm="0">
          <v-sheet
            v-resize="onResize"
            :height="height"
            id="scrolling-techniques-7"
            class="overflow-y-auto"
          >
            <v-container style="margin-bottom: 120px; padding: 0;">
              <v-card class="mx-auto" outlined>
                <v-virtual-scroll
                  :bench="benched"
                  :items="showEmployees"
                  :height="height"
                  item-height="64"
                >
                  <template v-slot:default="{ item }">
                    <v-list-item
                      v-if="item.active === 'Yes'"
                      :key="item.id"
                      :class="item.lastDraw"
                    >
                      <v-list-item-action>
                        <v-checkbox v-model="item.selected"></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.id }} - {{ item.firstName }}
                          {{ item.lastName }}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-btn icon @click="editEmployee(item)">
                          <v-icon color="primary">mdi-pencil</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>

                    <v-list-item v-else :key="item.id" :class="item.lastDraw">
                      <v-list-item-action>
                        <!-- <v-checkbox v-model="item.selected"></v-checkbox> -->
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.id }} - {{ item.firstName }}
                          {{ item.lastName }}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-btn
                          depressed
                          class="red lighten-1"
                          dark
                          @click="employeeStatus(item.id, 'Yes')"
                        >
                          Inactive
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>

                    <v-divider></v-divider>
                  </template>
                </v-virtual-scroll>
              </v-card>
            </v-container>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card>

    <v-speed-dial
      v-if="showUpload"
      v-model="fab"
      dark
      fixed
      right
      color="indigo"
      style="bottom: 80px;"
      direction="top"
      transition="slide-y-reverse-transition"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">
            mdi-chevron-down
          </v-icon>
          <v-icon v-else>
            mdi-account-switch
          </v-icon>
        </v-btn>
      </template>
      <v-tooltip left v-if="this.csv.length > 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            small
            v-bind="attrs"
            v-on="on"
            color="blue"
            @click="allList"
          >
            <v-icon>mdi-playlist-plus</v-icon>
          </v-btn>
        </template>
        <span>Load Entire List</span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            small
            v-bind="attrs"
            v-on="on"
            color="green"
            @click="onExport"
          >
            <v-icon>mdi-cloud-download</v-icon>
          </v-btn>
        </template>
        <span>Print List</span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            small
            v-bind="attrs"
            v-on="on"
            color="green"
            @click="sendExport"
          >
            <v-icon>mdi-email</v-icon>
          </v-btn>
        </template>
        <span>Email List</span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            small
            v-bind="attrs"
            v-on="on"
            color="green"
            @click="onPdfList"
          >
            <v-icon>mdi-file-pdf-box</v-icon>
          </v-btn>
        </template>
        <span>Print PDF List</span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            small
            v-bind="attrs"
            v-on="on"
            color="red"
            @click="showUpload = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Close</span>
      </v-tooltip>
    </v-speed-dial>

    <v-speed-dial
      v-else-if="showDraw"
      v-model="fab"
      dark
      fixed
      right
      color="indigo"
      style="bottom: 80px;"
      direction="top"
      transition="slide-y-reverse-transition"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">
            mdi-chevron-down
          </v-icon>
          <v-icon v-else>
            mdi-selection-ellipse-arrow-inside
          </v-icon>
        </v-btn>
      </template>
      <v-tooltip left v-if="drawSaved">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            small
            v-bind="attrs"
            v-on="on"
            color="green"
            @click="downloadPdf"
          >
            <v-icon>mdi-printer</v-icon>
          </v-btn>
        </template>
        <span>Print Draw</span>
      </v-tooltip>
      <v-tooltip left v-if="drawSaved">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            small
            v-bind="attrs"
            v-on="on"
            color="green"
            @click="sendDraw"
          >
            <v-icon>mdi-email</v-icon>
          </v-btn>
        </template>
        <span>Email Draw</span>
      </v-tooltip>
      <v-tooltip left v-if="!drawSaved">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            small
            v-bind="attrs"
            v-on="on"
            color="green"
            @click="updateDraw"
          >
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </template>
        <span>Save Draw</span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            small
            v-bind="attrs"
            v-on="on"
            color="red"
            @click="showDraw = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Close</span>
      </v-tooltip>
    </v-speed-dial>

    <v-btn
      class="mx-2"
      fab
      dark
      fixed
      right
      color="indigo"
      style="bottom: 80px;"
      @click="putEmployee()"
      v-else
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog
      v-model="showCompanyEdit"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="800px"
      scrollable
    >
      <v-card>
        <v-toolbar color="primary" dark>
          <v-btn icon dark @click="showCompanyEdit = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit Company</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-row class="pt-6">
            <v-col cols="12">
              <v-text-field v-model="company.name" label="Name"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="company.address"
                label="Address"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="company.city" label="City"></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="company.state"
                label="ST"
                v-mask="stateMask"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="company.zip"
                label="Zip"
                v-mask="zipMask"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="company.phone"
                label="Phone"
                v-mask="phoneMask"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="company.active"
                :items="yesno"
                label="Active"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <span class="text-h6 primary--text">Payment Info</span>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                v-model="company.amount"
                label="Amount"
                prefix="$"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-select
                v-model="company.CertificateId"
                :items="certificates"
                item-text="name"
                item-value="id"
                label="Certificate Type"
              ></v-select>
            </v-col>
            <v-col cols="6" md="4">
              <v-btn
                v-if="company.payStatus"
                depressed
                color="blue"
                @click="sendCertificate(company)"
              >
                Send Certificate
              </v-btn>
              <v-btn v-else depressed color="red" @click="sendInvoice(company)">
                Send Invoice
              </v-btn>
            </v-col>
            <v-col v-if="company.payStatus" cols="12">
              <v-btn
                v-if="company.payStatus"
                depressed
                color="red"
                @click="resetInvoice(company)"
              >
                Reset Invoice
              </v-btn>
            </v-col>
            <v-col v-if="company.payStatus" cols="12">
              <v-list>
                <template v-for="(invoice, index) in company.Invoices">
                  <v-lazy :key="index" transition="fade-transition">
                    <v-list-item>
                      <v-list-item-content class="text-left">
                        <v-list-item-title>
                          Unpaid Invoice(s): {{ invoice.id }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-lazy>
                </template>
              </v-list>
            </v-col>
            <v-col cols="12">
              <span class="text-h6 primary--text">Draw Schedule</span>
            </v-col>
            <v-col cols="4" md="2">
              <v-text-field
                v-model="company.dueDate"
                label="Day Due"
                v-mask="numberMask"
              ></v-text-field>
            </v-col>
            <v-col cols="8" md="10">
              <v-checkbox
                label="Select All"
                color="success"
                hide-details
                @click="updateMonths()"
              ></v-checkbox>
            </v-col>
            <v-col cols="4" md="2">
              <v-checkbox
                v-model="company.Jan"
                label="Jan"
                color="success"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-divider></v-divider>
            <v-col cols="4" md="2">
              <v-checkbox
                v-model="company.Feb"
                label="Feb"
                color="success"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="4" md="2">
              <v-checkbox
                v-model="company.Mar"
                label="Mar"
                color="success"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="4" md="2">
              <v-checkbox
                v-model="company.Apr"
                label="Apr"
                color="success"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="4" md="2">
              <v-checkbox
                v-model="company.May"
                label="May"
                color="success"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="4" md="2">
              <v-checkbox
                v-model="company.Jun"
                label="Jun"
                color="success"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="4" md="2">
              <v-checkbox
                v-model="company.Jul"
                label="Jul"
                color="success"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-divider></v-divider>
            <v-col cols="4" md="2">
              <v-checkbox
                v-model="company.Aug"
                label="Aug"
                color="success"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="4" md="2">
              <v-checkbox
                v-model="company.Sep"
                label="Sep"
                color="success"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="4" md="2">
              <v-checkbox
                v-model="company.Oct"
                label="Oct"
                color="success"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="4" md="2">
              <v-checkbox
                v-model="company.Nov"
                label="Nov"
                color="success"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="4" md="2">
              <v-checkbox
                v-model="company.Dec"
                label="Dec"
                color="success"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12">
              <span class="text-h6 primary--text">Draw Amounts</span>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="company.ConsortiumId"
                :items="consortiaList"
                item-text="name"
                item-value="id"
                label="Consortium"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="company.TestTypeId"
                :items="testTypes"
                item-text="name"
                item-value="id"
                label="Program Type"
              ></v-select>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                v-model="company.percentDrug"
                label="Drug Draw Percent"
                v-mask="drawMask"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                v-model="company.percentAlcohol"
                label="Drug/Alcohol Percent"
                v-mask="drawMask"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                v-model="company.amountDrug"
                label="Drug Draw"
                v-mask="drawMask"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                v-model="company.amountAlcohol"
                label="Drug/Alcohol Draw"
                v-mask="drawMask"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                v-model="company.drugAlternate"
                label="Alt Drug Draw"
                v-mask="drawMask"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                v-model="company.alcoholAlternate"
                label="Alt Drug/Alcohol Draw"
                v-mask="drawMask"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="company.description"
                label="Notes"
                counter
                maxlength="255"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span class="text-h6 primary--text">Contacts</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-list-item-group color="primary">
                <v-list-item v-for="(item, i) in company.Contacts" :key="i">
                  <v-list-item-icon @click="editContact(item)">
                    <v-icon>mdi-account-edit</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.name }}
                      <span v-if="item.title">({{ item.title }})</span>
                    </v-list-item-title>
                    <v-list-item-subtitle
                      v-text="item.email"
                    ></v-list-item-subtitle>
                    <v-list-item-subtitle
                      v-text="item.phone"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      v-if="item.active === 'Yes'"
                      depressed
                      color="green"
                      @click="contactStatus(item.id, 'No')"
                    >
                      Active
                    </v-btn>
                    <v-btn
                      v-else
                      depressed
                      color="red"
                      @click="contactStatus(item.id, 'Yes')"
                    >
                      Inactive
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="showContact()">
            Add Contact
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="updateCompany()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-dialog v-model="showContactEdit" max-width="500px">
        <v-card>
          <v-toolbar color="primary" dark>
            <v-btn icon dark @click="showContactEdit = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="contact.id">Edit Contact</v-toolbar-title>
            <v-toolbar-title v-else>Add Contact</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="contact.name"
                  label="Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="contact.title"
                  label="Title"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="contact.email"
                  label="Email"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="contact.phone"
                  label="Phone"
                  v-mask="phoneMask"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="contact.active"
                  :items="yesno"
                  label="Active"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="contact.id"
              color="primary"
              text
              @click="updateContact()"
            >
              Update
            </v-btn>
            <v-btn v-else color="primary" text @click="addContact()">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>

    <v-dialog v-model="showEmployeeEdit" width="500">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-btn icon dark @click="showEmployeeEdit = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="newEmployee.id">Edit Employee</v-toolbar-title>
          <v-toolbar-title v-else>Add Employee</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              {{ newEmployee.name }}
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="newEmployee.firstName"
                label="First Name (MI)"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="newEmployee.lastName"
                label="Last Name"
              ></v-text-field>
            </v-col>
            <v-col v-if="newEmployee.id" cols="6">
              <v-select
                v-model="newEmployee.active"
                :items="yesno"
                label="Active"
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="newEmployee.draws && newEmployee.draws.length">
            Company Draws
            <v-list class="pl-4">
              <template v-for="(employee, index) in newEmployee.draws">
                <v-lazy :key="index" transition="fade-transition">
                  <v-list-item link @click="updateList(employee)">
                    <v-list-item-title>
                      {{ employee.title }} - {{ employee.date }}
                    </v-list-item-title>
                  </v-list-item>
                </v-lazy>
                <v-divider
                  v-if="index + 1 < newEmployee.draws.length"
                  :key="`divider-${index}`"
                ></v-divider>
              </template>
            </v-list>
          </v-row>
          <v-row v-if="newEmployee.condraws && newEmployee.condraws.length">
            Consortium Draws
            <v-list class="pl-4">
              <template v-for="(employee, index) in newEmployee.condraws">
                <v-lazy :key="index" transition="fade-transition">
                  <v-list-item link @click="updateList(employee)">
                    <v-list-item-title>
                      {{ employee.title }} - {{ employee.date }}
                    </v-list-item-title>
                  </v-list-item>
                </v-lazy>
                <v-divider
                  v-if="index + 1 < newEmployee.condraws.length"
                  :key="`divider-${index}`"
                ></v-divider>
              </template>
            </v-list>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="newEmployee.id"
            color="primary"
            text
            @click="updateEmployee()"
          >
            Update
          </v-btn>
          <v-btn v-else color="primary" text @click="addEmployee(false)">
            Add
          </v-btn>
          <v-btn
            v-if="!newEmployee.id"
            color="primary"
            text
            @click="addEmployee(true)"
          >
            Add & Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import _ from 'lodash'
import Api from '@/services/Api'

const pdfMake = require('pdfmake/build/pdfmake.js')
const pdfFonts = require('pdfmake/build/vfs_fonts.js')
pdfMake.vfs = pdfFonts.pdfMake.vfs
import moment from 'moment'
import XLSX from 'xlsx'
import { mask } from 'vue-the-mask'

export default {
  name: 'company',

  directives: {
    mask,
  },

  data: () => ({
    benched: 0,
    showCompanyEdit: false,
    showEmployeeEdit: false,
    showContactEdit: false,
    stateMask: 'AA',
    zipMask: '#####',
    phoneMask: '(###) ###-####',
    drawMask: '###',
    numberMask: '##',
    yesno: ['Yes', 'No'],
    yesno1: ['yes', 'no'],
    fab: false,
    showDraw: false,
    showDraws: false,
    showDrawP: false,
    drawSaved: false,
    showUpload: false,
    parse_header: ['firstName', 'lastName'],
    parse_csv: [],
    loadButton: false,
    header: true,
    dialog: false,
    disable: true,
    companyId: 0,
    drawId: 0,
    companyName: '',
    prevDraws: [],
    prevConsort: false,
    prevConsortiumDraws: [],
    prevDraw: {},
    prevEmail: '',
    stats: {},
    contactId: 0,
    createdAt: '',
    amountDrug: 0,
    amountAlcohol: 0,
    amountAltDrug: 0,
    amountAltAlcohol: 0,
    emailTo: '',
    emailMe: false,
    randomDraw: [],
    randomAlcohol: [],
    randomAltDraw: [],
    randomAltAlcohol: [],
    company: [],
    employees: [],
    height: 400,
    indeterminate: false,
    loading: true,
    logo: '',
    sign: '',
    border: '',
    representative: '',
    menu: false,
    numberSelected: 'Select All',
    search: '',
    selectAll: true,
    selected: [],
    prevAmount: 0,
    printEmp: [],
    showEmployees: [],
    team: '',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.',
    csv: [],
    snackbar: {
      show: false,
      color: '',
      message: '',
    },
    newEmployee: {
      firstName: '',
      lastDraw: '',
    },
    contact: {},
    testTypes: [],
    certificates: [],
    consortiaList: [],
    showNewDraw: false,
    pendingDraws: [],
  }),

  created() {
    this.companyId = this.$route.params.id
    this.getLogo()
    this.getCompany()
    this.getTestTypes()
    this.getConsortia()
    this.getEmployees()
    this.getCertificates()
  },

  mounted() {
    this.onResize()
  },

  watch: {
    showEmployees: {
      // eslint-disable-next-line
      handler: function (val, oldVal) {
        // this.loading = true
        this.selected = _.filter(this.showEmployees, ['selected', true])

        const notSelected = _.filter(this.showEmployees, ['selected', false])

        if (this.selected === undefined || this.selected.length == 0) {
          this.indeterminate = false
          this.selectAll = false
        } else {
          if (notSelected === undefined || notSelected.length == 0) {
            this.selectAll = true
          } else {
            this.selectAll = false
          }

          if (!this.selectAll) {
            this.indeterminate = true
          }
        }

        if (this.selected.length > 0) {
          this.numberSelected = '(' + this.selected.length + ' selected)'
          this.disable = false
        } else {
          this.numberSelected = 'Select All'
          this.disable = true
        }

        this.loading = false
      },
      deep: true,
    },
  },

  methods: {
    onResize() {
      this.height = window.innerHeight - 380
    },

    async getLogo() {
      const response = await Api().get('get_logo')

      this.logo = response.data.logo
      this.sign = response.data.sign
      this.border = response.data.border
      this.representative = response.data.representative
    },

    async getCompany() {
      try {
        console.log('Enter')
        const response = await Api().get('companies/' + this.companyId)

        const company = response.data.company
        const draws = response.data.draws

        console.log('company', company)
        console.log('draws', draws)

        this.companyName = company.name

        let currentYear = moment().format('YYYY')
        let drawId = 0
        let totalDraws = 0
        let totalDrug = 0
        let totalAlcohol = 0
        let avgDraws = 0
        let noDraws = 0
        let companyDraws = []
        let companyDraw = {}

        company.CompanyPrevDraws = draws

        for (let n in draws) {
          let year = draws[n].createdAt.split('-')

          if (currentYear === year[0]) {
            companyDraw = draws[n]
            companyDraws.push(companyDraw)
            companyDraw = {}
          }
        }
        company.CompanyDraws = companyDraws

        for (let i in company.CompanyDraws) {
          drawId = company.CompanyDraws[i].id
          totalDraws += company.CompanyDraws[i].noEmployees
          totalDrug +=
            company.CompanyDraws[i].amountDrug +
            company.CompanyDraws[i].amountAlcohol
          totalAlcohol += company.CompanyDraws[i].amountAlcohol

          if (
            company.CompanyDraws[i].amountDrug > 0 ||
            company.CompanyDraws[i].amountAlcohol > 0
          ) {
            noDraws++
          }
        }

        if (company.CompanyDraws.length > 0) {
          avgDraws = Math.ceil(totalDraws / company.CompanyDraws.length)
        } else {
          avgDraws = company.Employees.length
        }

        let percentDrug = Math.floor((totalDrug / avgDraws) * 100)
        let percentAlcohol = Math.floor((totalAlcohol / avgDraws) * 100)

        this.stats.noDraws = noDraws
        this.stats.avgDraws = avgDraws
        this.stats.percentDrug = percentDrug + '% (' + totalDrug + ')'
        this.stats.percentAlcohol = percentAlcohol + '% (' + totalAlcohol + ')'

        this.amountDrug = company.amountDrug
        this.amountAlcohol = company.amountAlcohol

        let totalNumberD = 0
        let totalNumberA = 0
        let noDrug = 0
        let noAl = 0

        if (company.TestTypeId) {
          company.percentDrug = company.TestType.percentDrug
          company.percentAlcohol = company.TestType.percentAlcohol
        }

        if (company.percentDrug > 0) {
          totalNumberD = Math.ceil(avgDraws * (company.percentDrug / 100))

          noDrug = Math.ceil(
            (totalNumberD - totalDrug) /
              (company.drawsYear - this.stats.noDraws)
          )

          this.amountDrug = noDrug
        }

        if (company.percentAlcohol > 0) {
          totalNumberA = Math.ceil(avgDraws * (company.percentAlcohol / 100))

          noAl = Math.ceil(
            (totalNumberA - totalAlcohol) /
              (company.drawsYear - this.stats.noDraws)
          )

          this.amountAlcohol = noAl
        }
        console.log('company', company)
        console.log('totalNumberA', totalNumberA)
        console.log('noAl', noAl)

        if (this.amountDrug < 0) {
          this.amountDrug = 0
        }

        if (this.amountAlcohol < 0) {
          this.amountAlcohol = 0
        }

        this.amountAltDrug = company.drugAlternate
        this.amountAltAlcohol = company.alcoholAlternate

        this.drawId = drawId

        let firstTime = true
        for (let j in company.Contacts) {
          if (company.Contacts[j].active === 'Yes') {
            if (!firstTime) {
              this.emailTo += ', '
            } else {
              firstTime = false
            }

            this.emailTo += company.Contacts[j].email
          }
        }

        this.company = company

        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },

    async getTestTypes() {
      const clientId = this.$store.state.client.id

      try {
        let testTypes = {}
        testTypes.id = '0'
        testTypes.name = 'None'
        this.testTypes.push(testTypes)

        const response = await Api().get('test_types/' + clientId)

        for (let i in response.data) {
          testTypes = {}
          testTypes.id = response.data[i].id
          testTypes.name = response.data[i].name
          this.testTypes.push(testTypes)
        }
      } catch (e) {
        console.error(e)
      }
    },

    async resetInvoice(company) {
      try {
        console.log(company)

        this.company.payStatus = null
        const response = await Api().put(
          'companies/' + this.company.id,
          this.company
        )

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getCertificates() {
      const clientId = this.$store.state.client.id

      try {
        let certificates = {}
        certificates.id = '0'
        certificates.name = 'None'
        this.certificates.push(certificates)

        const response = await Api().get('certificates/' + clientId)

        for (let i in response.data) {
          certificates = {}
          certificates.id = response.data[i].id
          certificates.name = response.data[i].name
          this.certificates.push(certificates)
        }
      } catch (e) {
        console.error(e)
      }
    },

    showStats() {
      let totalDraws = 0
      let totalDrug = 0
      let totalAlcohol = 0
      let avgDraws = 0
      let noDraws = 0

      for (let i in this.company.CompanyDraws) {
        totalDraws += this.company.CompanyDraws[i].noEmployees
        totalDrug +=
          this.company.CompanyDraws[i].amountDrug +
          this.company.CompanyDraws[i].amountAlcohol
        totalAlcohol += this.company.CompanyDraws[i].amountAlcohol

        if (
          this.company.CompanyDraws[i].amountDrug > 0 ||
          this.company.CompanyDraws[i].amountAlcohol > 0
        ) {
          noDraws++
        }
      }

      if (this.company.CompanyDraws.length > 0) {
        avgDraws = Math.ceil(totalDraws / this.company.CompanyDraws.length)
      } else {
        avgDraws = this.company.Employees.length
      }

      let percentDrug = Math.floor((totalDrug / avgDraws) * 100)
      let percentAlcohol = Math.floor((totalAlcohol / avgDraws) * 100)

      this.stats.noDraws = noDraws
      this.stats.avgDraws = avgDraws
      this.stats.percentDrug = percentDrug + '% (' + totalDrug + ')'
      this.stats.percentAlcohol = percentAlcohol + '% (' + totalAlcohol + ')'

      this.amountDrug = this.company.amountDrug
      this.amountAlcohol = this.company.amountAlcohol

      let totalNumberD = 0
      let totalNumberA = 0
      let noDrug = 0
      let noAl = 0

      if (this.company.TestTypeId > 0) {
        this.company.percentDrug = this.company.TestType.percentDrug
        this.company.percentAlcohol = this.company.TestType.percentAlcohol
      }

      if (this.company.percentDrug > 0) {
        totalNumberD = Math.ceil(avgDraws * (this.company.percentDrug / 100))

        noDrug = Math.ceil(
          (totalNumberD - totalDrug) /
            (this.company.drawsYear - this.stats.noDraws)
        )

        this.amountDrug = noDrug
      }

      if (this.company.percentAlcohol > 0) {
        totalNumberA = Math.ceil(avgDraws * (this.company.percentAlcohol / 100))

        noAl = Math.ceil(
          (totalNumberA - totalDrug) /
            (this.company.drawsYear - this.stats.noDraws)
        )

        this.amountAlcohol = noAl
      }

      if (this.amountDrug < 0) {
        this.amountDrug = 0
      }

      if (this.amountAlcohol < 0) {
        this.amountAlcohol = 0
      }
    },

    async getEmployees() {
      try {
        const response = await Api().get('all_employees/' + this.companyId)
        const employees = response.data
        console.log('emp', employees)

        let row = {}
        const rows = []
        let row1 = {}
        const rows1 = []
        let lastDraw = ''
        let draw = {}
        let condraw = {}
        let draws = []
        let condraws = []

        for (let i in employees) {
          row['id'] = employees[i].id
          row['name'] = employees[i].name
          row['firstName'] = employees[i].firstName
          row['lastName'] = employees[i].lastName
          row['active'] = employees[i].active
          row1['firstName'] = employees[i].firstName
          row1['lastName'] = employees[i].lastName

          for (let j in employees[i].CompanyDraws) {
            if (this.drawId === employees[i].CompanyDraws[j].id) {
              lastDraw = 'red lighten-4'
            }

            draw['id'] = employees[i].CompanyDraws[j].id

            draw['date'] = moment(
              employees[i].CompanyDraws[j].createdAt
            ).format('MM/DD/YYYY h:mm:ss a')

            draw['title'] = employees[i].CompanyDraws[j].EmployeeDraw.title

            draws.push(draw)
            draw = {}
          }

          for (let j in employees[i].ConsortiumDraws) {
            console.log('con', employees[i].ConsortiumDraws[j])
            if (this.drawId === employees[i].ConsortiumDraws[j].id) {
              lastDraw = 'red lighten-4'
            }

            condraw['id'] = employees[i].ConsortiumDraws[j].id

            condraw['date'] = moment(
              employees[i].ConsortiumDraws[j].createdAt
            ).format('MM/DD/YYYY h:mm:ss a')

            condraw['title'] =
              employees[i].ConsortiumDraws[j].EmployeeConsortiumDraw.title

            condraws.push(condraw)
            condraw = {}
          }

          row['draws'] = draws
          row['condraws'] = condraws
          row['lastDraw'] = lastDraw

          if (employees[i].active === 'Yes') {
            row['selected'] = true
            rows1.push(row1)
          } else {
            row['selected'] = false
          }

          rows.push(row)
          row = {}
          row1 = {}
          draws = []
          condraws = []
          lastDraw = ''
        }

        this.employees = rows
        this.showEmployees = rows

        this.printEmp = rows1
      } catch (e) {
        console.error(e)
      }
    },

    selectAllTeam() {
      if (this.indeterminate) {
        this.indeterminate = false
        this.selectAll = true
      }

      for (var i in this.showEmployees) {
        this.showEmployees[i].selected = this.selectAll
      }
    },

    searchProducts() {
      this.loading = true

      if (this.search) {
        if (this.search.length > 3) {
          let search = this.search.toLowerCase()
          this.team = 'All'

          let employees = _.filter(this.employees, function(obj) {
            if (obj.firstName.toLowerCase().indexOf(search) !== -1) {
              return obj.firstName.toLowerCase().indexOf(search) !== -1
            }

            if (obj.lastName.toLowerCase().indexOf(search) !== -1) {
              return obj.lastName.toLowerCase().indexOf(search) !== -1
            }
          })

          this.showEmployees = employees
        }
      } else {
        this.showEmployees = this.employees
      }

      this.loading = false
    },

    newDraw() {
      this.showNewDraw = true
      this.showDraw = true

      for (let i in this.company.CompanyDraws) {
        if (this.company.CompanyDraws[i].status === 'Pending') {
          this.company.CompanyDraws[i].createdAt = moment(
            this.company.CompanyDraws[i].createdAt
          )
            .local()
            .format('MM/DD/YYYY')

          this.pendingDraws.push(this.company.CompanyDraws[i])
        } else {
          this.showNewDraw = false
          this.getRandom()
        }
      }
    },

    getRandom() {
      this.showDraw = true
      this.showDraws = false
      this.showUpload = false
      this.drawSaved = false
      this.prevAmount = 0

      var drawList = this.selected.map(obj => ({ ...obj }))
      console.log(drawList, this.amountDrug, this.amountAlcohol)

      if (drawList.length < this.amountDrug) {
        this.snackbar.message = 'There are more draws then there are employees!'
        this.snackbar.color = 'error'
        this.snackbar.show = true
        return
      }

      this.randomDraw = []
      this.randomAlcohol = []
      this.randomAltDraw = []
      this.randomAltAlcohol = []

      var random = []
      var randomAlcohol = []
      var altDrug = []
      var altAlcohol = []

      for (var i = 0; i < this.amountDrug; i++) {
        var shuffled = drawList[Math.floor(Math.random() * drawList.length)]

        random.push(shuffled)

        _.remove(drawList, function(e) {
          return e.id === shuffled.id
        })
      }

      for (var j = 0; j < this.amountAlcohol; j++) {
        var alcohol = random[Math.floor(Math.random() * random.length)]

        randomAlcohol.push(alcohol)

        _.remove(random, function(e) {
          return e.id === alcohol.id
        })
      }

      if (this.amountAltDrug > 0) {
        for (var k = 0; k < this.amountAltDrug; k++) {
          var shuffledAD = drawList[Math.floor(Math.random() * drawList.length)]

          altDrug.push(shuffledAD)

          _.remove(drawList, function(e) {
            return e.id === shuffledAD.id
          })
        }

        for (var l = 0; l < this.amountAltAlcohol; l++) {
          var alcoholAlt = altDrug[Math.floor(Math.random() * altDrug.length)]

          altAlcohol.push(alcoholAlt)

          _.remove(altDrug, function(e) {
            return e.id === alcoholAlt.id
          })
        }

        this.randomAltDraw = altDrug
        this.randomAltAlcohol = altAlcohol
      }

      this.randomDraw = random
      this.randomAlcohol = randomAlcohol
    },

    async getPrevious() {
      try {
        this.prevDraws = []
        this.loading1 = true
        this.showUpload = false
        this.showDraw = false
        this.showDraws = true
        this.showDrawp = false
        let draw = {}

        const response = await Api().get(
          'consortium_company_draw/' + this.companyId
        )

        this.prevConsortiumDraws = []
        const consortiumDraws = response.data

        for (let j in consortiumDraws) {
          console.log(consortiumDraws[j])
          draw.id = consortiumDraws[j].id
          draw.number = consortiumDraws[j].noEmployees

          draw.date = moment(consortiumDraws[j].createdAt).format(
            'MM/DD/YYYY h:mm:ss a'
          )

          draw.date = draw.date + ' - ' + consortiumDraws[j].name
          draw.createdAt = consortiumDraws[j].createdAt

          this.prevConsortiumDraws.push(draw)
          draw = {}
        }

        for (let i in this.company.CompanyPrevDraws) {
          draw.id = this.company.CompanyPrevDraws[i].id
          draw.number = this.company.CompanyPrevDraws[i].noEmployees

          draw.date = moment(this.company.CompanyPrevDraws[i].createdAt).format(
            'MM/DD/YYYY h:mm:ss a'
          )

          this.prevDraws.push(draw)
          draw = {}
        }

        this.loading1 = false
      } catch (e) {
        console.error(e)
      }
    },

    async getDraw(id) {
      try {
        this.loading1 = true
        this.showDraws = false
        this.showDraw = true
        this.drawSaved = true
        let drawinfo = {}
        this.randomDraw = []
        this.randomAlcohol = []
        this.randomAltDraw = []
        this.randomAltAlcohol = []

        const response = await Api().get('company_draw/' + id)

        const draw = response.data

        console.log('draw', draw)

        for (let i in draw.Employees) {
          drawinfo.active = 'Yes'
          drawinfo.id = draw.Employees[i].id
          drawinfo.companyId = this.companyId
          drawinfo.companyName = this.companyName
          drawinfo.firstName = draw.Employees[i].firstName
          drawinfo.lastName = draw.Employees[i].lastName
          drawinfo.name = draw.Employees[i].name

          if (draw.Employees[i].EmployeeDraw.title === 'Drug') {
            this.randomDraw.push(drawinfo)
          } else if (draw.Employees[i].EmployeeDraw.title === 'Drug-Alcohol') {
            this.randomAlcohol.push(drawinfo)
          } else if (draw.Employees[i].EmployeeDraw.title === 'Alt Drug') {
            this.randomAltDraw.push(drawinfo)
          } else {
            this.randomAltAlcohol.push(drawinfo)
          }
          console.log(drawinfo)
          drawinfo = {}
        }

        this.prevAmount = draw.noEmployees
        this.prevDraw = draw
        // console.log(draw)
        this.loading1 = false
      } catch (e) {
        console.error(e)
      }
    },

    async getCoDraw(id, did, createdAt) {
      try {
        this.loading1 = true
        this.showDraws = false
        this.showDraw = true
        this.drawSaved = true
        this.prevConsort = true
        let drawinfo = {}
        this.randomDraw = []
        this.randomAlcohol = []
        this.createdAt = createdAt

        const response = await Api().get('consortium_co_draw/' + id + '/' + did)

        const draw = response.data

        console.log('draw', draw)

        for (let i in draw) {
          drawinfo.active = 'Yes'
          drawinfo.id = draw[i].id
          drawinfo.companyId = this.companyId
          drawinfo.companyName = this.companyName
          drawinfo.firstName = draw[i].firstName
          drawinfo.lastName = draw[i].lastName
          drawinfo.name = draw[i].name
          this.prevAmount = draw[i].noEmployees

          if (draw[i].title === 'Drug') {
            this.randomDraw.push(drawinfo)
            this.amountDrug++
          } else if (draw[i].title === 'Drug-Alcohol') {
            this.randomAlcohol.push(drawinfo)
            this.amountAlcohol++
          }

          console.log(drawinfo)
          drawinfo = {}
        }

        this.prevDraw = draw
        console.log('draw', draw)
        this.loading1 = false
      } catch (e) {
        console.error(e)
      }
    },

    updateEmail() {
      if (this.emailMe) {
        this.prevEmail = this.emailTo
        this.emailTo = this.$store.state.user.email
      } else {
        this.emailTo = this.prevEmail
      }
    },

    getUpload() {
      this.showUpload = true
      this.showDraw = false
      this.showDraws = false
    },

    updateMonths() {
      this.company.Jan = !this.company.Jan
      this.company.Feb = !this.company.Feb
      this.company.Mar = !this.company.Mar
      this.company.Apr = !this.company.Apr
      this.company.May = !this.company.May
      this.company.Jun = !this.company.Jun
      this.company.Jul = !this.company.Jul
      this.company.Aug = !this.company.Aug
      this.company.Sep = !this.company.Sep
      this.company.Oct = !this.company.Oct
      this.company.Nov = !this.company.Nov
      this.company.Dec = !this.company.Dec
    },

    csvJSON(csv) {
      const vm = this
      const lines = csv.split(/\r?\n/)
      const result = []

      lines.map(function(line, indexLine) {
        if (indexLine < 1 && vm.header === true) return // Jump header line

        const obj = {}
        line = line.replace('\r', '')
        const currentline = line.split(',')

        vm.parse_header.map(function(header, indexHeader) {
          obj[header] = currentline[indexHeader]
        })

        result.push(obj)
      })

      return result // JavaScript object
    },

    async loadCSV(e) {
      const vm = this

      try {
        if (window.FileReader) {
          const reader = new FileReader()
          reader.readAsText(e)

          // Handle errors load
          reader.onload = function(event) {
            const csv = event.target.result
            vm.parse_csv = vm.csvJSON(csv)
          }

          reader.onerror = function(evt) {
            if (evt.target.error.name === 'NotReadableError') {
              alert('Cannot read file!')
            }
          }
        } else {
          alert('FileReader are not supported in this browser.')
        }

        this.loadButton = true
      } catch (e) {
        console.error(e)
      }
    },

    async updateCompany() {
      try {
        const response = await Api().put(
          'companies/' + this.company.id,
          this.company
        )

        this.showStats()

        this.showCompanyEdit = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateList(employee) {
      let integer = 0
      let message = ''

      try {
        // if (employee.action === 'CHANGE') {
        //   integer = parseInt(employee.id, 10)

        //   let formData = {}
        //   formData.name = employee.name
        //   formData.active = 'yes'
        //   formData.CompanyId = this.companyId

        //   await Api().put('employees/' + integer, formData)

        //   let objIndex = this.showEmployees.findIndex(obj => obj.id == integer)

        //   this.showEmployees[objIndex].name = employee.name
        //   this.selected[objIndex].name = employee.name
        //   this.employees[objIndex].name = employee.name

        //   employee.action = ''
        //   message = 'Employee updated!'
        // } else if (employee.action === 'DELETE') {
        if (employee.action === 'DELETE') {
          let formData = {}
          formData.CompanyId = this.companyId
          formData.firstName = employee.firstName
          formData.lastName = employee.lastName
          formData.active = 'no'

          await Api().put('remove_employee/', formData)

          this.showEmployees = _.reject(this.showEmployees, function(el) {
            return el.id === integer
          })

          this.selected = _.reject(this.selected, function(el) {
            return el.id === integer
          })

          this.employees = _.reject(this.employees, function(el) {
            return el.id === integer
          })

          employee.action = ''
          message = 'Employee moved inactive!'
        } else if (employee.action === 'ADD') {
          let empSave = {}
          empSave.name = employee.firstName + ' ' + employee.lastName
          empSave.firstName = employee.firstName
          empSave.lastName = employee.lastName
          empSave.active = 'yes'
          empSave.CompanyId = this.companyId

          const response = await Api().post('employees', empSave)

          employee.draws = []
          employee.lastDraw = ''
          employee.selected = true
          employee.action = ''
          employee.id = response.data.employee.id

          this.selected.push(employee)
          this.employees.push(employee)
          message = 'Employee added!'
        }

        this.snackbar.message = message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async allList() {
      let message = ''

      try {
        for (let i in this.csv) {
          if (this.csv[i].action === 'ADD') {
            let empSave = {}
            empSave.name = this.csv[i].name
            empSave.active = 'yes'
            empSave.CompanyId = this.companyId

            const response = await Api().post('employees', empSave)

            this.csv[i].draws = []
            this.csv[i].lastDraw = ''
            this.csv[i].selected = true
            this.csv[i].action = ''
            this.csv[i].id = response.data.employee.id

            this.selected.push(this.csv[i])
            this.employees.push(this.csv[i])
          }
        }

        message = 'Employees added!'
        this.snackbar.message = message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    putEmployee() {
      this.newEmployee = {}
      this.showEmployeeEdit = true
    },

    editEmployee(employee) {
      this.newEmployee = employee
      this.showEmployeeEdit = true
    },

    async getConsortia() {
      const clientId = this.$store.state.client.id

      try {
        let consortiaList = {}
        consortiaList.id = '0'
        consortiaList.name = 'None'
        this.consortiaList.push(consortiaList)

        const response = await Api().get('just_consortia/' + clientId)

        for (let i in response.data) {
          consortiaList = {}
          consortiaList.id = response.data[i].id
          consortiaList.name = response.data[i].name
          this.consortiaList.push(consortiaList)
        }
      } catch (e) {
        console.error(e)
      }
    },

    async employeeStatus(employeeId, active) {
      try {
        let formData = {}
        formData.active = active

        const response = await Api().put('employees/' + employeeId, formData)

        let objIndex = this.showEmployees.findIndex(obj => obj.id == employeeId)

        this.showEmployees[objIndex].active = active
        this.showEmployees[objIndex].selected = true

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async addEmployee(closeDialog) {
      let empSave = {}

      try {
        empSave.name =
          this.newEmployee.firstName + ' ' + this.newEmployee.lastName
        empSave.firstName = this.newEmployee.firstName
        empSave.lastName = this.newEmployee.lastName
        empSave.active = 'yes'
        empSave.CompanyId = this.companyId

        const response = await Api().post('employees', empSave)

        let employee = {}
        employee.name = empSave.name
        employee.draws = []
        employee.lastDraw = ''
        employee.selected = true
        employee.id = response.data.employee.id

        this.selected.push(employee)
        this.employees.push(employee)
        this.newEmployee.firstName = ''
        this.newEmployee.lastName = ''

        if (closeDialog) {
          this.showEmployeeEdit = false
        }

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    editContact(contact) {
      this.contact = contact
      this.showContactEdit = true
    },

    showContact() {
      this.contact = {}
      this.contact.active = 'Yes'
      this.showContactEdit = true
    },

    async addContact() {
      try {
        this.contact.CompanyId = this.company.id
        const response = await Api().post('contacts', this.contact)

        this.company.Contacts.push(response.data.contact)

        this.emailTo = ''
        let firstTime = true
        for (let j in this.company.Contacts) {
          if (this.company.Contacts[j].active === 'Yes') {
            if (!firstTime) {
              this.emailTo += ', '
            } else {
              firstTime = false
            }

            this.emailTo += this.company.Contacts[j].email
          }
        }

        this.showContactEdit = false

        this.contact.name = ''
        this.contact.title = ''
        this.contact.email = ''
        this.contact.phone = ''
        this.contact.active = 'Yes'

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateEmployee() {
      try {
        let formData = {}
        formData.name =
          this.newEmployee.firstName + ' ' + this.newEmployee.lastName
        formData.firstName = this.newEmployee.firstName
        formData.lastName = this.newEmployee.lastName
        formData.active = this.newEmployee.active

        const response = await Api().put(
          'employees/' + this.newEmployee.id,
          formData
        )

        let objIndex = this.showEmployees.findIndex(
          obj => obj.id == this.newEmployee.id
        )

        if (this.newEmployee.active === 'No') {
          this.showEmployees[objIndex].selected = false
        } else {
          this.showEmployees[objIndex].name = formData.name
          this.selected[objIndex].name = this.newEmployee.name
          this.employees[objIndex].name = this.newEmployee.name
        }

        this.showEmployeeEdit = false

        this.showContactEdit = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateContact() {
      try {
        const response = await Api().put(
          'contacts/' + this.contact.id,
          this.contact
        )

        this.emailTo = ''
        let firstTime = true
        for (let j in this.company.Contacts) {
          if (this.company.Contacts[j].active === 'Yes') {
            if (!firstTime) {
              this.emailTo += ', '
            } else {
              firstTime = false
            }

            this.emailTo += this.company.Contacts[j].email
          }
        }

        this.showContactEdit = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async contactStatus(contactId, active) {
      try {
        let formData = {}
        formData.active = active

        const response = await Api().put('contacts/' + contactId, formData)

        let objIndex = this.company.Contacts.findIndex(
          obj => obj.id == contactId
        )

        this.company.Contacts[objIndex].active = active

        this.emailTo = ''
        let firstTime = true
        for (let j in this.company.Contacts) {
          if (this.company.Contacts[j].active === 'Yes') {
            if (!firstTime) {
              this.emailTo += ', '
            } else {
              firstTime = false
            }

            this.emailTo += this.company.Contacts[j].email
          }
        }

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    addList() {
      for (let p in this.parse_csv) {
        let pFirstName = this.parse_csv[p].firstName.toUpperCase().trim()
        let pLastName = this.parse_csv[p].lastName.toUpperCase().trim()

        for (let q in this.printEmp) {
          let cFirstName = this.printEmp[q].firstName.toUpperCase().trim()
          let cLastName = this.printEmp[q].lastName.toUpperCase().trim()

          if (cFirstName === pFirstName && cLastName === pLastName) {
            this.parse_csv[p].action = 'Good'
            break
          } else {
            this.parse_csv[p].action = 'ADD'
          }
        }

        if (this.parse_csv[p].action === 'ADD') {
          this.csv.push(this.parse_csv[p])
        }
      }

      for (let i in this.printEmp) {
        this.printEmp[i].firstName = this.printEmp[i].firstName.trim()
        this.printEmp[i].lastName = this.printEmp[i].lastName.trim()
        let pFirstName = this.printEmp[i].firstName.toUpperCase()
        let pLastName = this.printEmp[i].lastName.toUpperCase()
        let status = ''

        for (let j in this.parse_csv) {
          let cFirstName = this.parse_csv[j].firstName.toUpperCase().trim()
          let cLastName = this.parse_csv[j].lastName.toUpperCase().trim()

          if (cFirstName === pFirstName && cLastName === pLastName) {
            status = 'Good'
            break
          } else {
            this.printEmp[i].action = 'DELETE'
            status = 'Delete'
          }
        }

        if (status === 'Delete') {
          this.csv.push(this.printEmp[i])
        }
      }

      let test = this.csv.sort((a, b) => {
        let fa = a.firstName.toLowerCase(),
          fb = b.firstName.toLowerCase()

        if (fa < fb) {
          return -1
        }
        if (fa > fb) {
          return 1
        }

        return 0
      })

      this.csv = test
      // let result3 = _(this.printEmp)
      //   .differenceBy(this.parse_csv, 'id', 'lastName')
      //   .map(_.partial(_.pick, _, 'id', 'lastName'))
      //   .value()

      // let result4 = _(this.parse_csv)
      //   .differenceBy(this.printEmp, 'id', 'lastName')
      //   .map(_.partial(_.pick, _, 'id', 'lastName'))
      //   .value()

      // for (let i in this.parse_csv) {
      //   let id = this.parse_csv[i].id.toUpperCase()
      //   if (id === 'NEW' || id === '') {
      //     this.parse_csv[i].action = 'ADD'
      //   } else if (result4.some(item => item.id === this.parse_csv[i].id)) {
      //     this.parse_csv[i].action = 'CHANGE'
      //   } else {
      //     this.parse_csv[i].action = ''
      //   }

      //   this.csv.push(this.parse_csv[i])
      // }

      // for (let j in result3) {
      //   let temp = '' + result3[j].id

      //   if (result4.some(item => item.id === temp)) {
      //     console.log('test')
      //   } else {
      //     result3[j].action = 'DELETE'
      //     this.csv.push(result3[j])
      //   }
      // }
    },

    clearMessage() {
      this.search = ''
      this.showEmployees = this.employees
    },

    async saveDraw() {
      let currentDate = moment().format('MM/DD/YYYY h:mm:ss a')
      let printDate = moment().format('YYYY-MM-DD')

      let drug = this.amountDrug - this.amountAlcohol
      let drugAlt = this.amountAltDrug - this.amountAltAlcohol
      let amount = this.printEmp.length

      try {
        let draw = {}
        draw.currentDate = currentDate
        draw.printDate = printDate
        draw.drug = drug
        draw.drugAlt = drugAlt
        draw.amount = amount
        draw.amountAlcohol = this.amountAlcohol
        draw.alcololAlt = this.amountAltAlcohol
        draw.emailId = this.contactId
        draw.email = this.emailTo
        draw.company = this.company
        draw.randomDraw = this.randomDraw
        draw.randomAlcohol = this.randomAlcohol
        draw.randomAltDraw = this.randomAltDraw
        draw.randomAltAlcohol = this.randomAltAlcohol
        draw.userId = this.$store.state.user.id

        const response = await Api().post('save_draw', draw)
        this.drawSaved = true

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateDraw() {
      let currentDate = moment().format('MM/DD/YYYY h:mm:ss a')
      let printDate = moment().format('YYYY-MM-DD_h-mm-ss')

      let drug = this.amountDrug - this.amountAlcohol
      let drugAlt = this.amountAltDrug - this.amountAltAlcohol
      let amount = this.printEmp.length

      try {
        let draw = {}
        draw.currentDate = currentDate
        draw.printDate = printDate
        draw.drug = drug
        draw.drugAlt = drugAlt
        draw.amount = amount
        draw.amountAlcohol = this.amountAlcohol
        draw.alcololAlt = this.amountAltAlcohol
        draw.emailId = this.contactId
        draw.email = this.emailTo
        draw.company = this.company
        draw.randomDraw = this.randomDraw
        draw.randomAlcohol = this.randomAlcohol
        draw.randomAltDraw = this.randomAltDraw
        draw.randomAltAlcohol = this.randomAltAlcohol
        draw.userId = this.$store.state.user.id

        const response = await Api().post('save_draw', draw)
        this.drawSaved = true

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async sendDraw() {
      let currentDate = moment().format('MM/DD/YYYY h:mm:ss a')
      let printDate = moment().format('YYYY-MM-DD_h-mm-ss')
      let amount = 0

      let drug = this.amountDrug - this.amountAlcohol
      let alcohol = this.amountAlcohol
      let drugAlt = this.amountAltDrug - this.amountAltAlcohol

      if (this.prevAmount > 0) {
        amount = this.prevAmount

        if (this.prevConsort) {
          drug = this.amountDrug
          alcohol = this.amountAlcohol
          currentDate = moment(this.createdAt).format('MM/DD/YYYY h:mm:ss a')
          printDate = moment(this.createdAt).format('YYYY-MM-DD')
        } else {
          drug = this.prevDraw.amountDrug
          alcohol = this.prevDraw.amountAlcohol
          currentDate = moment(this.prevDraw.createdAt).format(
            'MM/DD/YYYY h:mm:ss a'
          )
        }
      } else {
        amount = this.printEmp.length
      }

      try {
        let draw = {}
        draw.currentDate = currentDate
        draw.printDate = printDate
        draw.drug = drug
        draw.drugAlt = drugAlt
        draw.amount = amount
        draw.amountAlcohol = alcohol
        draw.alcololAlt = this.amountAltAlcohol
        draw.emailId = this.contactId
        draw.email = this.emailTo
        draw.company = this.company
        draw.randomDraw = this.randomDraw
        draw.randomAlcohol = this.randomAlcohol
        draw.randomAltDraw = this.randomAltDraw
        draw.randomAltAlcohol = this.randomAltAlcohol
        draw.userId = this.$store.state.user.id
        draw.client = this.$store.state.client

        console.log('draw', draw)

        const response = await Api().post('print_pdf', draw)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    sendInvoice(item) {
      let printDate = moment().format('YYYY-MM-DD')
      let currentYear = moment()
        .add(1, 'years')
        .format('YYYY')
      console.log(item)

      let client =
        item.Client.name +
        '\n' +
        item.Client.address +
        '\n' +
        item.Client.city +
        ', ' +
        item.Client.state +
        ' ' +
        item.Client.zip +
        '\n' +
        item.Client.email

      let billTo =
        item.name +
        '\n' +
        item.address +
        '\n' +
        item.city +
        ', ' +
        item.state +
        ' ' +
        item.zip

      let docDefinition = {
        content: [
          {
            text: client,
            alignment: 'left',
            absolutePosition: { x: 50, y: 50 },
          },

          {
            image: 'data:image/jpeg;base64,' + this.logo,
            width: 100,
            alignment: 'right',
            margin: [0, -20, 0, 0],
          },

          {
            text: 'Invoice',
            style: 'header',
          },

          {
            text: 'Bill To:',
            alignment: 'left',
            bold: true,
            margin: [25, 10, 0, 0],
          },

          {
            text: billTo,
            alignment: 'left',
            margin: [25, 10, 20, 0],
          },

          {
            layout: 'headerLineOnly',
            table: {
              headerRows: 1,
              widths: ['*', '*', '*', '*', '*'],

              body: [
                ['Invoice #', 'Date', 'Total Due', 'Date Due', 'Terms'],
                ['21500', '01/01/2024', '$275.00', '01/31/2024', 'Net 30'],
              ],
            },
            margin: [20, 20, 20, 0],
          },

          {
            layout: 'lightHorizontalLines',
            table: {
              headerRows: 1,
              widths: ['*', 50, 50, 50],

              body: [
                ['Description', 'Qty', 'Rate', 'Amount'],
                [
                  currentYear + ' ' + item.Certificate.name,
                  { text: '1', alignment: 'right' },
                  { text: '$275.00', alignment: 'right' },
                  { text: '$275.00', alignment: 'right' },
                ],
              ],
            },
            margin: [20, 20, 20, 0],
          },

          {
            layout: 'headerLineOnly',
            table: {
              widths: ['*', 50],

              body: [
                [
                  { text: 'Balance Due', alignment: 'right' },
                  { text: '$275.00', bold: true, alignment: 'right' },
                ],
              ],
            },
            margin: [20, 20, 20, 0],
          },

          {
            text: [
              'Please send payment to the address on this invoice. Thank you for your business!',
            ],
            margin: [20, 10, 20, 30],
          },

          {
            text: 'Credit Card Info',
            style: 'header',
          },

          {
            layout: 'headerLineOnly',
            table: {
              widths: [100, '*'],

              body: [
                ['Company Name: ', { text: item.name, bold: true }],
                [' ', ' '],
                [
                  'Card Number: ',
                  { text: ' ', fillColor: 'gray', fillOpacity: 0.2 },
                ],
                [' ', ' '],
                [
                  'Name on Card: ',
                  { text: ' ', fillColor: 'gray', fillOpacity: 0.2 },
                ],
                [' ', ' '],
                [
                  'Expire Date: ',
                  { text: ' ', fillColor: 'gray', fillOpacity: 0.2 },
                ],
                [' ', ' '],
                [
                  'Security Code: ',
                  { text: ' ', fillColor: 'gray', fillOpacity: 0.25 },
                ],
                [' ', ' '],
                [
                  'Zip Code on Card: ',
                  { text: ' ', fillColor: 'gray', fillOpacity: 0.25 },
                ],
                [' ', ' '],
                [' ', ' '],
                [
                  'Signature: ',
                  { text: ' ', fillColor: 'gray', fillOpacity: 0.25 },
                ],
              ],
            },
            margin: [20, 5, 0, 0],
          },

          {
            text: '*There is a 4% additional fee for credit card payments!',
            fontSize: 9,
            alignment: 'center',
            bold: true,
            margin: [20, 5, 10, 0],
          },

          {
            text: 'If any information is incorrect, please let us know.',
            margin: [20, 10, 20, 30],
          },
        ],

        styles: {
          header: {
            fontSize: 18,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 10],
          },
        },
      }

      pdfMake
        .createPdf(docDefinition)
        .download(this.company.id + '_' + printDate + '_invoice.pdf')
    },

    sendCertificate(item) {
      // let currentYear = moment()
      //   .add(1, 'years')
      //   .format('YYYY')
      // let currentDate = moment().format('MM/DD/YYYY')
      let printDate = moment().format('YYYY-MM-DD')
      const client = this.$store.state.client
      // console.log(client)

      let para3 =
        'Enrollment in the ' +
        item.Certificate.name +
        ' is effective January 1, 2024 and will continue through December 31, 2024.  Annual membership renewal will be due on January 1, 2025.'

      let docDefinition = {
        background: {
          image: 'data:image/jpeg;base64,' + this.border,
          absolutePosition: { x: 25, y: 25 },
        },

        content: [
          {
            text: item.Certificate.name,
            style: 'header',
          },

          {
            text: '2024',
            fontSize: 18,
            margin: [0, 0, 0, 10],
            bold: true,
            alignment: 'center',
          },

          {
            text: [
              'I, Tonica Lathrop (Representative), certify that ',
              { text: item.name, bold: true },
              ' (Company) ',
              item.Certificate.description,
            ],
            margin: [25, 10, 25, 0],
          },

          {
            text: para3,
            margin: [25, 10, 25, 0],
          },

          {
            text: 'Consortium Program Information:',
            margin: [25, 50, 25, 0],
          },

          {
            layout: 'headerLineOnly',
            table: {
              widths: [110, '*'],

              body: [
                ['Organization Name: ', { text: client.name, bold: true }],
                [
                  'Address: ',
                  {
                    text:
                      client.address +
                      ', ' +
                      client.city +
                      ' ' +
                      client.state +
                      ' ' +
                      client.zip,
                    bold: true,
                  },
                ],
                ['Phone Number: ', { text: client.phone, bold: true }],
                ['Contact Person: ', { text: client.contact, bold: true }],
              ],
            },
            margin: [25, 10, 25, 0],
          },

          {
            image: 'data:image/jpeg;base64,' + this.representative,
            width: 150,
            alignment: 'left',
            absolutePosition: { x: 70, y: 690 },
          },

          {
            text: 'Signature of Authorized Representative:',
            absolutePosition: { x: 65, y: 720 },
          },

          {
            text: 'Date: 01/01/2024',
            absolutePosition: { x: 65, y: 735 },
          },
        ],

        styles: {
          header: {
            fontSize: 18,
            bold: true,
            alignment: 'center',
            margin: [0, 200, 0, 10],
          },
        },
      }

      pdfMake
        .createPdf(docDefinition)
        .download(this.company.id + '_' + printDate + '_certificate.pdf')
    },

    downloadPdf() {
      let currentDate = moment().format('MM/DD/YYYY h:mm:ss a')
      let printDate = moment().format('YYYY-MM-DD')

      let drug = this.amountDrug - this.amountAlcohol
      let drugAlt = this.amountAltDrug - this.amountAltAlcohol

      let docDefinition = {
        footer: function(currentPage, pageCount) {
          return [
            {
              text: currentPage.toString() + ' of ' + pageCount,
              margin: [25, 0, 0, 0],
              alignment: 'center',
            },
          ]
        },

        header: {
          text: currentDate,
          alignment: 'right',
          margin: [0, 20, 25, 0],
        },

        content: [
          {
            image: 'data:image/jpeg;base64,' + this.logo,
            width: 100,
            alignment: 'left',
            margin: [0, -20, 0, 0],
          },

          {
            text: 'Testing Notification',
            style: 'header',
          },

          {
            text: this.companyName,
            margin: [0, 10, 0, 10],
            bold: true,
            alignment: 'center',
          },
        ],

        styles: {
          header: {
            fontSize: 18,
            bold: true,
            alignment: 'center',
            margin: [0, 20, 0, 10],
          },
        },
      }

      if (this.randomDraw.length > 0) {
        let dr = {
          text:
            'Dear  ' +
            this.randomDraw[i].name +
            ': ' +
            ' ' +
            drug +
            ' Employee(s) selected from a pool of ' +
            this.showEmployees.length,
          bold: true,
          alignment: 'center',
          margin: [0, 0, 0, 10],
        }

        docDefinition.content.push(dr)

        let section = {
          columns: [
            { text: 'ID', bold: true, width: '20%' },
            { text: 'Name', bold: true },
          ],
        }

        docDefinition.content.push(section)

        for (var i in this.randomDraw) {
          let name = {
            columns: [
              { text: this.randomDraw[i].id, width: '20%' },
              { text: this.randomDraw[i].name, alignment: 'left' },
            ],
          }

          docDefinition.content.push(name)
        }
      }

      let img1 = {
        image: 'data:image/jpeg;base64,' + this.logo,
        width: 100,
        alignment: 'left',
        margin: [0, -20, 0, 0],
        pageBreak: 'before',
      }

      let titlea = {
        text: 'Random Selection of Employees Testing',
        style: 'header',
      }

      let titleb = {
        text: this.companyName,
        margin: [0, 10, 0, 10],
        bold: true,
        alignment: 'center',
      }

      let sectiona = {
        columns: [
          { text: 'ID', bold: true, width: '20%' },
          { text: 'Name', bold: true },
        ],
      }

      if (this.randomAlcohol.length > 0) {
        if (this.randomDraw.length > 25) {
          docDefinition.content.push(img1)
          docDefinition.content.push(titlea)
          docDefinition.content.push(titleb)
        }

        let da = {
          text:
            'BOTH DRUG AND ALCOHOL TEST: ' +
            ' ' +
            this.amountAlcohol +
            ' Employee(s) selected from a pool of ' +
            this.selected.length,
          bold: true,
          alignment: 'center',
          margin: [0, 20, 0, 10],
        }

        docDefinition.content.push(da)

        docDefinition.content.push(sectiona)

        for (var j in this.randomAlcohol) {
          let name = {
            columns: [
              { text: this.randomAlcohol[j].id, width: '20%' },
              { text: this.randomAlcohol[j].name, alignment: 'left' },
            ],
          }
          docDefinition.content.push(name)
        }
      }

      if (this.randomAltDraw.length > 0) {
        if (this.randomAlcohol.length > 25) {
          docDefinition.content.push(img1)
          docDefinition.content.push(titlea)
          docDefinition.content.push(titleb)
        }

        let altDa = {
          text:
            'DRUG (ALTERNATE): ' +
            ' ' +
            drugAlt +
            ' Employee(s) selected from a pool of ' +
            this.showEmployees.length,
          bold: true,
          alignment: 'center',
          margin: [0, 20, 0, 10],
        }

        docDefinition.content.push(altDa)

        sectiona = {
          columns: [
            { text: 'ID', bold: true, width: '20%' },
            { text: 'Name', bold: true },
          ],
        }

        docDefinition.content.push(sectiona)

        for (var k in this.randomAltDraw) {
          let name2 = {
            columns: [
              { text: this.randomAltDraw[k].id, width: '20%' },
              { text: this.randomAltDraw[k].name, alignment: 'left' },
            ],
          }
          docDefinition.content.push(name2)
        }
      }

      if (this.randomAltAlcohol.length > 0) {
        if (this.randomAltDraw.length > 25) {
          docDefinition.content.push(img1)
          docDefinition.content.push(titlea)
          docDefinition.content.push(titleb)
        }

        let altDaAl = {
          text:
            'DRUG/ALCOHOL (ALTERNATE): ' +
            ' ' +
            this.amountAltAlcohol +
            ' Employee(s) selected from a pool of ' +
            this.showEmployees.length,
          bold: true,
          alignment: 'center',
          margin: [0, 20, 0, 10],
        }

        docDefinition.content.push(altDaAl)

        sectiona = {
          columns: [
            { text: 'ID', bold: true, width: '20%' },
            { text: 'Name', bold: true },
          ],
        }

        docDefinition.content.push(sectiona)

        for (var l in this.randomAltAlcohol) {
          let name2 = {
            columns: [
              { text: this.randomAltAlcohol[l].id, width: '20%' },
              { text: this.randomAltAlcohol[l].name, alignment: 'left' },
            ],
          }
          docDefinition.content.push(name2)
        }
      }

      let title = {
        text:
          'Random selection was performed according to requirements specified under 49 CFR Part §382.305.',
        alignment: 'left',
        margin: [0, 20, 0, 10],
      }

      docDefinition.content.push(title)

      let witness = {
        text: 'Witness by:',
        alignment: 'left',
        margin: [0, 10, 0, 10],
      }

      docDefinition.content.push(witness)

      let sign = {
        image: 'data:image/jpeg;base64,' + this.sign,
        width: 200,
        alignment: 'left',
      }

      docDefinition.content.push(sign)

      pdfMake
        .createPdf(docDefinition)
        .download(this.company.id + '_' + printDate + '_draw.pdf')
    },

    downloadPdf1() {
      let currentDate = moment().format('MM/DD/YYYY h:mm:ss a')
      let printDate = moment().format('YYYY-MM-DD')

      let drug = this.amountDrug - this.amountAlcohol
      let drugAlt = this.amountAltDrug - this.amountAltAlcohol

      let docDefinition = {
        footer: function(currentPage, pageCount) {
          return [
            {
              text: currentPage.toString() + ' of ' + pageCount,
              margin: [25, 0, 0, 0],
              alignment: 'center',
            },
          ]
        },

        header: {
          text: currentDate,
          alignment: 'right',
          margin: [0, 20, 25, 0],
        },

        content: [
          {
            image: 'data:image/jpeg;base64,' + this.logo,
            width: 100,
            alignment: 'left',
            margin: [0, -20, 0, 0],
          },

          {
            text: 'Random Selection of Employees Testing',
            style: 'header',
          },

          {
            text: this.companyName,
            margin: [0, 10, 0, 10],
            bold: true,
            alignment: 'center',
          },
        ],

        styles: {
          header: {
            fontSize: 18,
            bold: true,
            alignment: 'center',
            margin: [0, 20, 0, 10],
          },
        },
      }

      if (this.randomDraw.length > 0) {
        let dr = {
          text:
            'DRUG TEST ONLY: ' +
            ' ' +
            drug +
            ' Employee(s) selected from a pool of ' +
            this.showEmployees.length,
          bold: true,
          alignment: 'center',
          margin: [0, 0, 0, 10],
        }

        docDefinition.content.push(dr)

        let section = {
          columns: [
            { text: 'ID', bold: true, width: '20%' },
            { text: 'Name', bold: true },
          ],
        }

        docDefinition.content.push(section)

        for (var i in this.randomDraw) {
          let name = {
            columns: [
              { text: this.randomDraw[i].id, width: '20%' },
              { text: this.randomDraw[i].name, alignment: 'left' },
            ],
          }

          docDefinition.content.push(name)
        }
      }

      let img1 = {
        image: 'data:image/jpeg;base64,' + this.logo,
        width: 100,
        alignment: 'left',
        margin: [0, -20, 0, 0],
        pageBreak: 'before',
      }

      let titlea = {
        text: 'Random Selection of Employees Testing',
        style: 'header',
      }

      let titleb = {
        text: this.companyName,
        margin: [0, 10, 0, 10],
        bold: true,
        alignment: 'center',
      }

      let sectiona = {
        columns: [
          { text: 'ID', bold: true, width: '20%' },
          { text: 'Name', bold: true },
        ],
      }

      if (this.randomAlcohol.length > 0) {
        if (this.randomDraw.length > 25) {
          docDefinition.content.push(img1)
          docDefinition.content.push(titlea)
          docDefinition.content.push(titleb)
        }

        let da = {
          text:
            'BOTH DRUG AND ALCOHOL TEST: ' +
            ' ' +
            this.amountAlcohol +
            ' Employee(s) selected from a pool of ' +
            this.selected.length,
          bold: true,
          alignment: 'center',
          margin: [0, 20, 0, 10],
        }

        docDefinition.content.push(da)

        docDefinition.content.push(sectiona)

        for (var j in this.randomAlcohol) {
          let name = {
            columns: [
              { text: this.randomAlcohol[j].id, width: '20%' },
              { text: this.randomAlcohol[j].name, alignment: 'left' },
            ],
          }
          docDefinition.content.push(name)
        }
      }

      if (this.randomAltDraw.length > 0) {
        if (this.randomAlcohol.length > 25) {
          docDefinition.content.push(img1)
          docDefinition.content.push(titlea)
          docDefinition.content.push(titleb)
        }

        let altDa = {
          text:
            'DRUG (ALTERNATE): ' +
            ' ' +
            drugAlt +
            ' Employee(s) selected from a pool of ' +
            this.showEmployees.length,
          bold: true,
          alignment: 'center',
          margin: [0, 20, 0, 10],
        }

        docDefinition.content.push(altDa)

        sectiona = {
          columns: [
            { text: 'ID', bold: true, width: '20%' },
            { text: 'Name', bold: true },
          ],
        }

        docDefinition.content.push(sectiona)

        for (var k in this.randomAltDraw) {
          let name2 = {
            columns: [
              { text: this.randomAltDraw[k].id, width: '20%' },
              { text: this.randomAltDraw[k].name, alignment: 'left' },
            ],
          }
          docDefinition.content.push(name2)
        }
      }

      if (this.randomAltAlcohol.length > 0) {
        if (this.randomAltDraw.length > 25) {
          docDefinition.content.push(img1)
          docDefinition.content.push(titlea)
          docDefinition.content.push(titleb)
        }

        let altDaAl = {
          text:
            'DRUG/ALCOHOL (ALTERNATE): ' +
            ' ' +
            this.amountAltAlcohol +
            ' Employee(s) selected from a pool of ' +
            this.showEmployees.length,
          bold: true,
          alignment: 'center',
          margin: [0, 20, 0, 10],
        }

        docDefinition.content.push(altDaAl)

        sectiona = {
          columns: [
            { text: 'ID', bold: true, width: '20%' },
            { text: 'Name', bold: true },
          ],
        }

        docDefinition.content.push(sectiona)

        for (var l in this.randomAltAlcohol) {
          let name2 = {
            columns: [
              { text: this.randomAltAlcohol[l].id, width: '20%' },
              { text: this.randomAltAlcohol[l].name, alignment: 'left' },
            ],
          }
          docDefinition.content.push(name2)
        }
      }

      let title = {
        text:
          'Random selection was performed according to requirements specified under 49 CFR Part §382.305.',
        alignment: 'left',
        margin: [0, 20, 0, 10],
      }

      docDefinition.content.push(title)

      let witness = {
        text: 'Witness by:',
        alignment: 'left',
        margin: [0, 10, 0, 10],
      }

      docDefinition.content.push(witness)

      let sign = {
        image: 'data:image/jpeg;base64,' + this.sign,
        width: 200,
        alignment: 'left',
      }

      docDefinition.content.push(sign)

      pdfMake
        .createPdf(docDefinition)
        .download(this.company.id + '_' + printDate + '_draw.pdf')
    },

    async sendExport() {
      let printDate = moment().format('YYYY-MM-DD')

      try {
        let draw = {}
        draw.companyId = this.companyId
        draw.companyName = this.companyName
        draw.printDate = printDate
        draw.email = this.emailTo
        draw.list = this.printEmp

        const response = await Api().post('send_export', draw)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    onExport() {
      let membersWS = XLSX.utils.json_to_sheet(this.printEmp)

      let wb = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(wb, membersWS, 'Members')

      XLSX.writeFile(wb, this.companyName + '.csv')
      // XLSX.writeFile(test, this.companyName + '.xlsx')
    },

    onPdfList() {
      let currentDate = moment().format('MM/DD/YYYY h:mm:ss a')
      let printDate = moment().format('YYYY-MM-DD')
      const client = this.$store.state.client

      let docDefinition = {
        footer: function(currentPage, pageCount) {
          return [
            {
              text:
                client.address +
                ', ' +
                client.city +
                ', ' +
                client.state +
                ' ' +
                client.zip +
                ' - Page ' +
                currentPage.toString() +
                ' of ' +
                pageCount,
              margin: [25, 0, 0, 0],
              alignment: 'left',
            },
          ]
        },

        header: {
          text: currentDate,
          alignment: 'right',
          margin: [0, 20, 25, 0],
        },

        content: [
          {
            image: 'data:image/jpeg;base64,' + this.logo,
            width: 100,
            alignment: 'left',
            margin: [0, -20, 0, 0],
          },

          {
            text: 'Employee List',
            style: 'header',
          },

          {
            text: this.companyName,
            margin: [0, 10, 0, 10],
            bold: true,
            alignment: 'center',
          },
        ],

        styles: {
          header: {
            fontSize: 18,
            bold: true,
            alignment: 'center',
            margin: [0, 20, 0, 10],
          },
        },
      }

      for (var l in this.selected) {
        if (this.selected[l].active === 'Yes') {
          console.log('name:', this.selected[l].name)
          let name3 = {
            columns: [
              { text: this.selected[l].id, width: '20%' },
              { text: this.selected[l].name, alignment: 'left' },
            ],
          }
          docDefinition.content.push(name3)
        }
      }
      pdfMake
        .createPdf(docDefinition)
        .download(this.company.id + '_' + printDate + '_draw.pdf')
    },
  },
}
</script>
